var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "footer__gallery" },
    _vm._l(_vm.feed, function (insta, i) {
      return _c("li", { attrs: { "data-bg": insta.imageUrl } }, [
        _c("a", { attrs: { href: insta.url, target: "_blank" } }, [
          _c("div", { staticClass: "footer__social" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "26",
                  height: "26",
                  viewBox: "0 0 26 26",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M13,2.311a39.861,39.861,0,0,1,5.2.144,6.7,6.7,0,0,1,2.456.433,5.073,5.073,0,0,1,2.456,2.456A6.7,6.7,0,0,1,23.544,7.8c0,1.3.144,1.733.144,5.2a39.861,39.861,0,0,1-.144,5.2,6.7,6.7,0,0,1-.433,2.456,5.073,5.073,0,0,1-2.456,2.456,6.7,6.7,0,0,1-2.456.433c-1.3,0-1.733.144-5.2.144a39.86,39.86,0,0,1-5.2-.144,6.7,6.7,0,0,1-2.456-.433,5.073,5.073,0,0,1-2.456-2.456A6.7,6.7,0,0,1,2.456,18.2c0-1.3-.144-1.733-.144-5.2a39.861,39.861,0,0,1,.144-5.2,6.7,6.7,0,0,1,.433-2.456A5.188,5.188,0,0,1,3.9,3.9,2.442,2.442,0,0,1,5.344,2.889,6.7,6.7,0,0,1,7.8,2.456,39.861,39.861,0,0,1,13,2.311M13,0A42.679,42.679,0,0,0,7.656.144,8.917,8.917,0,0,0,4.478.722,5.655,5.655,0,0,0,2.167,2.167,5.655,5.655,0,0,0,.722,4.478,6.581,6.581,0,0,0,.144,7.656,42.679,42.679,0,0,0,0,13a42.679,42.679,0,0,0,.144,5.344,8.917,8.917,0,0,0,.578,3.178,5.655,5.655,0,0,0,1.444,2.311,5.655,5.655,0,0,0,2.311,1.444,8.917,8.917,0,0,0,3.178.578A42.68,42.68,0,0,0,13,26a42.68,42.68,0,0,0,5.344-.144,8.917,8.917,0,0,0,3.178-.578,6.06,6.06,0,0,0,3.756-3.756,8.917,8.917,0,0,0,.578-3.178C25.856,16.9,26,16.467,26,13a42.68,42.68,0,0,0-.144-5.344,8.917,8.917,0,0,0-.578-3.178,5.655,5.655,0,0,0-1.444-2.311A5.655,5.655,0,0,0,21.522.722,8.917,8.917,0,0,0,18.344.144,42.679,42.679,0,0,0,13,0m0,6.356A6.537,6.537,0,0,0,6.356,13,6.644,6.644,0,1,0,13,6.356m0,10.978A4.256,4.256,0,0,1,8.667,13,4.256,4.256,0,0,1,13,8.667,4.256,4.256,0,0,1,17.333,13,4.256,4.256,0,0,1,13,17.333M19.933,4.478a1.589,1.589,0,1,0,1.589,1.589,1.6,1.6,0,0,0-1.589-1.589",
                    "fill-rule": "evenodd",
                  },
                }),
              ]
            ),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }